import React from 'react';
import { useLocalstorage } from 'hooks';
import { useTranslation } from 'react-i18next';
import {
    DiagnosisGeneral,
    DiagnosisGrouped
} from './components';

const GENERAL = 'diagnosis_general';
const GROUPED = 'diagnosis_grouped';

const StatisticsAbsenteesm = () => {

    const { t } = useTranslation();

    const [selectedTab, setSelectedTab] = useLocalstorage('statistics-diagnosis-tab', {
        defaultValue: GENERAL
    });

    const tabController = {
        selectedTab,
        setSelectedTab,
        tabs: [{
            label: t('General'),
            value: GENERAL
        }, {
            label: t('Por clasificación'),
            value: GROUPED
        }].filter(({ hidden }) => !hidden)
    };

    switch (selectedTab) {
    case (GENERAL): return <DiagnosisGeneral tabController={ tabController } />;
    case (GROUPED): return <DiagnosisGrouped tabController={ tabController } />;
    default: return <DiagnosisGeneral tabController={ tabController } />;
    }
};

StatisticsAbsenteesm.propTypes = {

};

export default StatisticsAbsenteesm;
